import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

const VideoPlayer = ({ src, height = 250 }) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current && videoRef.current) {
      playerRef.current = videojs(videoRef.current, {
        controls: true,
        preload: "auto",
        fluid: false,
        responsive: false,
        sources: [{ src, type: "video/mp4" }],
      });

      playerRef.current.ready(() => {
        playerRef.current.height(height);
        playerRef.current.width('100%');
      });
    }
  }, [src, height]);

  return (
    <div 
      data-vjs-player 
      style={{ 
        height: `${height}px`,
      }}
    > 
      <video
        ref={videoRef}
        className="video-js vjs-default-skin"
        style={{
          width:'100%',
        }}
      ></video>
    </div>
  );
};
export default VideoPlayer;
